module.exports = __webpack_public_path__ + "static/media/PaytoneOne.ff30c906.woff2";